export { default } from './ArticleLink';
